import { FC } from "react";

interface LeagueBannerProps {
    bannerSrc: string;
    bannerUrl: string;
    leagueName?: string;
    title?: string;
}
export const LeagueBanner: FC<LeagueBannerProps> = ({
    bannerSrc,
    bannerUrl,
    leagueName = 'Лига',
    title = "Перейти к турнирной таблице",
}) => {
    const linkTarget = bannerUrl.startsWith('http') ? '_blank' : '_self';
    return (
        <div className="w-full flex items-center justify-center overflow-hidden bg-black rounded-lg sm:rounded-none">
            <a href={bannerUrl} title={title} target={linkTarget}>
                <img className="w-full h-auto max-w-[1024px]" src={bannerSrc} alt={leagueName} />
            </a>
        </div>
    );
}